@import 'styles/variables';
@import 'styles/mixins.scss';
@import 'styles/blaze/mixins';

.emailBoldText {
  font-weight: 600;
}

.form {
  display: flex;
  flex-direction: column;
  height: 316px;
  gap: 12px;

  @include for-tablet-portrait-max {
    height: auto;
  }

  @include for-desktop-only {
    height: initial;
    gap: 4px;
  }
}

.title {
  margin-bottom: 16px;
}

.submitButton {
  margin: 24px 0 24px auto;
}

.content {
  @include for-desktop-only {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 40px;
    height: 100%;
    margin: 0 auto;
    width: 450px;

    .title {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 8px;
    }

    .buttonsContainer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 36px;
    }
  }
}
